<template>
    <div class="tips-wrapper" :style="styles">{{ message }}</div>
</template>

<script>
export default {
    name: "Tips",
    props: ["message", "position", "algin"],
    computed: {
        styles() {
            const { left, top, width, height } = this.position;
            if (this.algin === "middle" && this.$el) {
                return {
                    left: `${left - (this.$el.offsetWidth / 2 - width / 2)}px`,
                    top: `${top + height}px`
                };
            }
            return {
                left: `${left}px`,
                top: `${top + height}px`
            };
        }
    }
};
</script>

<style lang="less" scoped>
.tips-wrapper {
    background: #333333;
    border-radius: 2px;
    font-size: 12px;
    padding: 6px;
    color: #fff;
    max-width: 450px;
    position: fixed;
    top: -9999px;
    left: -9999px;
}
</style>
